/* NaaS configurator (src/components/UnifiedConfigurator.tsx). REVIEW-BG draft.
 * The PDF quote stays in English (jsPDF Helvetica has no Cyrillic). */
import type { Catalogue } from "./index";
import { POP_COUNT_LABEL } from "@/lib/network-metrics";
import { DWDM_CAPACITY_RANGE_LABEL } from "@/lib/pricing";

export const COUNTRY_BG: Catalogue = {
  Bulgaria: "България",
  Germany: "Германия",
  Turkey: "Турция",
  Greece: "Гърция",
  UK: "Великобритания",
  Georgia: "Грузия",
  UAE: "ОАЕ",
  Armenia: "Армения",
};

export const CONFIGURATOR_BG: Catalogue = {
  // Products
  "IP Transit": "IP Transit",
  "Ethernet / L2VPN": "Ethernet / L2VPN",
  "Wavelengths (DWDM)": "DWDM вълни",
  "Dark Fiber": "Тъмно влакно",
  "Sofia & Frankfurt · 1G–400G": "София и Франкфурт · 1G–400G",
  [`All ${POP_COUNT_LABEL} PoPs · Up to 10G`]: `Всички ${POP_COUNT_LABEL} PoP-а · до 10G`,
  [`All ${POP_COUNT_LABEL} PoPs · ${DWDM_CAPACITY_RANGE_LABEL}`]: `Всички ${POP_COUNT_LABEL} PoP-а · ${DWDM_CAPACITY_RANGE_LABEL}`,
  "Sofia metro today": "Засега в рамките на София",

  // Step headers
  "Choose a Product": "Изберете услуга",
  "Select the connectivity service you need": "Изберете услугата за свързаност, която ви трябва",
  "Fiber Distance": "Дължина на влакното",
  "How many meters of dark fiber do you need?": "Колко метра тъмно влакно ви трябват?",
  "Select Route": "Изберете трасе",
  "Choose origin and destination PoPs": "Изберете начален и краен PoP",
  "Select Capacity": "Изберете капацитет",
  "Choose your bandwidth": "Изберете скорост",
  "Sofia — Equinix SO1/SO2, Telepoint": "София — Equinix SO1/SO2, Telepoint",
  "Contract Terms": "Условия на договора",
  "Choose commitment and redundancy options": "Изберете срок и резервираност",

  // Dark fibre
  "Distance presets": "Готови дължини",
  "500m": "500 м",
  "1 km": "1 км",
  "5 km": "5 км",
  "10 km": "10 км",
  Custom: "Друга",
  "Custom distance in meters": "Друга дължина в метри",
  meters: "метра",
  "Pricing Model": "Ценови модел",
  "Monthly Lease": "Месечен наем",
  "€0.03/m/mo": "€0,03/м/мес.",
  "IRU 15 Years": "IRU за 15 години",
  "€1.00/m + O&M": "€1,00/м + поддръжка",

  // Route step
  "Selecting: Origin": "Избирате: начало",
  "Selecting: Destination": "Избирате: дестинация",
  Origin: "Начало",
  Destination: "Дестинация",
  unavailable: "не е налично",
  "IP Transit is delivered only from Sofia and Frankfurt": "IP Transit се доставя само от София и Франкфурт",
  "Dark Fiber is in service only within the Sofia metro today — planned routes are on a roadmap enquiry path":
    "Тъмното влакно засега е налично само в рамките на София. За планираните трасета изпратете запитване.",
  "Not currently available": "Засега не е налично",
  "estimated round-trip latency": "ориентировъчно RTT",
  "Caucasus routing": "Трасе през Кавказ",
  "Middle East routing": "Трасе към Близкия изток",
  "Pricing includes international terrestrial segment via Turkey/Georgia.":
    "Цената включва международния наземен участък през Турция и Грузия.",
  "Pricing includes extended international segment via subsea & terrestrial routes.":
    "Цената включва удължен международен участък по подводни и наземни трасета.",
  "Network Topology": "Топология на мрежата",
  "Network map showing PoP locations across Europe, Caucasus, and Middle East":
    "Карта на мрежата с PoP-овете в Европа, Кавказ и Близкия изток",
  Internet: "Интернет",
  Subsea: "Подводно",
  "Caucasus Cable System (CCS)": "Caucasus Cable System (CCS)",
  "Route includes Black Sea submarine cable segment — Balchik (BG) to Poti (GE). Bypasses Türkiye terrestrial transit.":
    "Трасето включва подводен участък през Черно море от Балчик (BG) до Поти (GE) и заобикаля наземния транзит през Турция.",
  "Submarine Cable Route": "Трасе с подводен кабел",
  "Route includes submarine cable segment through the Middle East corridor":
    "Трасето включва подводен участък през коридора към Близкия изток",
  "Pricing info": "Информация за цената",
  "Direct fiber routes via Sofia Connect backbone": "Директни оптични трасета по магистралата на Sofia Connect",
  "International terrestrial segment via Turkey/Georgia included": "Включен е международен наземен участък през Турция и Грузия",
  "Extended international segment via subsea & terrestrial routes included":
    "Включен е удължен международен участък по подводни и наземни трасета",
  "Sofia Connect Edge — domestic Bulgarian backbone, sub-10ms from Sofia":
    "Sofia Connect Edge — национална магистрала, под 10 ms от София",

  // Capacity step
  Bandwidth: "Скорост",
  "/mo": "/мес.",
  " IRU (15yr)": " IRU (15 г.)",
  "Burst Model": "Модел на таксуване",
  "Flat Rate": "Фиксирана цена",
  "Fixed monthly cost": "Фиксиран месечен разход",
  "95th Percentile": "95-и персентил",
  "Pay for actual usage, save ~15%": "Плащате реалното ползване, около 15% по-евтино",

  // Terms step
  "Commitment Period": "Срок на договора",
  months: "месеца",
  discount: "отстъпка",
  Redundancy: "Резервираност",
  "Single Path": "Едно трасе",
  "Standard connectivity": "Стандартна свързаност",
  "Protected 1+1": "Защита 1+1",
  "+30% · Automatic failover": "+30% · Автоматично превключване",
  "Fully Redundant": "Пълна резервираност",
  "+60% · Diverse paths": "+60% · Независими трасета",

  // Review step
  "Your Configuration": "Вашата конфигурация",
  "Save this configuration for comparison": "Запазете конфигурацията за сравнение",
  Compare: "Сравни",
  "Start Over": "Започни отначало",
  "Configuration Summary": "Обобщение",
  Location: "Локация",
  Distance: "Дължина",
  Model: "Модел",
  Provisioning: "Срок за изграждане",
  Capacity: "Капацитет",
  Commitment: "Срок",
  Route: "Трасе",
  Latency: "Закъснение",
  Bulgaria: "България",
  "Sofia — Equinix SO1/SO2": "София — Equinix SO1/SO2",
  "Pricing Breakdown": "Разбивка на цената",
  "Base monthly": "Базова месечна цена",
  "Commitment discount": "Отстъпка за срок",
  mo: "мес.",
  "95th percentile model": "Модел 95-и персентил",
  "Redundancy surcharge": "Надбавка за резервираност",
  "Total monthly": "Общо на месец",
  "Total contract": "Общо за договора",
  "Quote ref:": "Номер на офертата:",
  "Valid 30 days · Indicative pricing, final quote may vary.":
    "Валидна 30 дни · Ориентировъчна цена, окончателната оферта може да се различава.",
  "Enterprise Configuration": "Корпоративна конфигурация",
  "Custom pricing available — our sales team can offer volume discounts for this configuration.":
    "Възможна е индивидуална цена. Екипът по продажби може да предложи отстъпка за обем.",
  "Quote Request Sent": "Запитването е изпратено",
  "Our sales team will respond within 24 hours.": "Екипът по продажби ще отговори до 24 часа.",
  "Reference:": "Номер:",
  "Your Contact Details": "Данни за контакт",
  Name: "Име",
  Company: "Компания",
  Email: "Имейл",
  Phone: "Телефон",
  "John Smith": "Иван Иванов",
  "Acme Corp": "Компания ЕООД",
  "Name is required": "Въведете име",
  "Company is required": "Въведете компания",
  "Valid email is required": "Въведете валиден имейл",
  "Download PDF Quote": "Изтегли оферта в PDF",
  "Sending...": "Изпращане…",
  "Send Quote Request": "Изпрати запитване",
  "Failed to send. Please try again or": "Изпращането не успя. Опитайте отново или",
  "use the contact form": "използвайте формата за контакт",
  "Link copied!": "Връзката е копирана!",
  "Copy shareable link": "Копирай връзка за споделяне",

  // Navigation
  "Configuration steps": "Стъпки на конфигурацията",
  Step: "Стъпка",
  completed: "завършена",
  current: "текуща",
  Back: "Назад",
  "Back to previous step": "Към предишната стъпка",
  "Previous step": "Предишна стъпка",
  Review: "Преглед",
  Continue: "Напред",
  "Review your configuration": "Прегледайте конфигурацията",
  "Continue to next step": "Към следващата стъпка",

  // Sidebar readout
  route: "трасе",
  latency: "RTT",
  ready: "готово за",
  Save: "Спестявате",
  "/yr O&M": "/год. поддръжка",
  Enterprise: "Корпоративна",
  "Indicative · Depends on route & contract": "Ориентировъчно · Зависи от трасето и договора",
  "Indicative · Final quote may vary": "Ориентировъчно · Окончателната оферта може да се различава",
  "Saved Config": "Запазена конфигурация",
  Price: "Цена",
  Difference: "Разлика",
  "Starting from": "От",
  Estimated: "Ориентировъчно",
};
